const STORAGE_KEY_PREFIX = 'gecko_doc_nav_preview_mode:v1'

function getStorageKey(siteId: string): string {
  return `${STORAGE_KEY_PREFIX}_${siteId}`
}

export function readPreviewModePreference(siteId: string): boolean | null {
  try {
    const raw = localStorage.getItem(getStorageKey(siteId))
    if (raw === 'true') return true
    if (raw === 'false') return false
    return null
  } catch {
    return null
  }
}

export function writePreviewModePreference(
  siteId: string,
  isPreviewMode: boolean
): void {
  try {
    localStorage.setItem(getStorageKey(siteId), String(isPreviewMode))
  } catch {
    /* localStorage unavailable */
  }
}

export function clearPreviewModePreference(siteId: string): void {
  try {
    localStorage.removeItem(getStorageKey(siteId))
  } catch {
    /* localStorage unavailable */
  }
}
